import { handleApiRequest } from '../services/transports';

import { REACT_APP_RSD_DOMAIN } from './base';

export const login = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Login/LoginUser`,
  method: 'post',
  data
});

export const getPrivileges = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Utility/service-privileges-by-username`,
  method: 'get',
  query
});

export const smpCompanyStatus = () => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}rsd-api/portal/SMPUsers/smp-company-status`,
  method: 'get'
});


export const mpResetPassword = email => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-reset-password/${email}`,
  method: 'post'
});
export const sopResetPassword = email => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/sop-reset-password/${email}`,
  method: 'post'
});
export const submitSmpRecoveryPassword = email => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/smp-reset-password/${email}`,
  method: 'post'
});

